"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _recording;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingService = void 0;
const Service_1 = require("../Service");
const events_1 = require("../../events");
const index_1 = require("../../events/recording/index");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
const Recording_1 = __importDefault(require("../../models/Recording"));
/**
 * @ignore
 */
var RecordingServiceEvents;
(function (RecordingServiceEvents) {
    RecordingServiceEvents["Status"] = "status";
    RecordingServiceEvents["Started"] = "started";
    RecordingServiceEvents["Stopped"] = "stopped";
})(RecordingServiceEvents || (RecordingServiceEvents = {}));
/**
 * @ignore
 */
var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["Recording"] = "RECORDING";
    RecordingStatus["NotRecording"] = "NOT_RECORDING";
})(RecordingStatus || (RecordingStatus = {}));
/**
 * The RecordingService allows an application to record conferences by using the [start](#start) and [stop](#stop)
 * methods that turn the recording on and off.
 *
 * @noInheritDoc
 */
let RecordingService = class RecordingService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     */
    constructor(sdk) {
        super(sdk);
        /**
         * The current recording
         */
        _recording.set(this, null);
    }
    /**
     * Starts recording a conference. For more information, see the [Recording mechanisms](doc:guides-recording-mechanisms) article or the [Recording](doc:recording) document.
     */
    start() {
        return VoxeetApi_1.default.conferences.startRecording({ conferenceId: this._conferenceId });
    }
    /**
     * Stops recording a conference.
     */
    stop() {
        return VoxeetApi_1.default.conferences.stopRecording({ conferenceId: this._conferenceId });
    }
    onConferenceJoined(event) {
        super.onConferenceJoined(event);
        this.onRecordingStatusUpdated(index_1.RecordingStatusUpdated.fromJoinEvent(event));
    }
    onConferenceLeft(event) {
        super.onConferenceLeft(event);
        __classPrivateFieldSet(this, _recording, null);
    }
    onRecordingStatusUpdated(event) {
        if (event.status === RecordingStatus.NotRecording) {
            if (__classPrivateFieldGet(this, _recording) !== null) {
                const recording = __classPrivateFieldGet(this, _recording);
                __classPrivateFieldSet(this, _recording, null);
                this.emit(RecordingServiceEvents.Stopped, recording);
            }
        }
        else if (event.status === RecordingStatus.Recording) {
            __classPrivateFieldSet(this, _recording, new Recording_1.default(event.participantId, event.startTimestamp));
            this.emit(RecordingServiceEvents.Started, __classPrivateFieldGet(this, _recording));
        }
    }
    /**
     * Returns information about the current recording. Use this accessor if you wish to receive information that is available in the [Recording](model/recording) object, such as the [ID](doc:js-client-sdk-model-recording#participantid) of the participant who started the recording or the [timestamp](doc:js-client-sdk-model-recording#starttimestamp) that informs when the recording was started.
     */
    get current() {
        return __classPrivateFieldGet(this, _recording);
    }
};
_recording = new WeakMap();
__decorate([
    Service_1.ConferenceNotNull()
], RecordingService.prototype, "start", null);
__decorate([
    Service_1.ConferenceNotNull()
], RecordingService.prototype, "stop", null);
RecordingService = __decorate([
    Service_1.Subscribe([events_1.EventType.RecordingStatusUpdated])
], RecordingService);
exports.RecordingService = RecordingService;
